// main class
class MediaFileType {
  value = 'ALL'
  text = 'Все типы'
  anyFormat = '' // 'image/*'
  formats = [] // ['.pdf']
  constructor (value, text, anyFormat = '', formats = []) {
    if (value) this.value = value
    this.text = text
    this.anyFormat = anyFormat
    this.formats = formats
  }
}

// types list
const mediaFileTypes = [
  new MediaFileType('ALL', 'Все типы'),
  new MediaFileType('IMAGE', 'Изображение', '.jpg, .jpeg, .gif, .png, .apng, .bmp, .webp'),
  new MediaFileType('VIDEO', 'Видео', '.mp4, .webm'),
  new MediaFileType('AUDIO', 'Аудио', 'mp3, .wav'),
  new MediaFileType('PDF', 'PDF Документ', 'application/pdf'),
  new MediaFileType('OTHER', 'Другое')
]

// interfaces:

//  { value: mediaFileType }
export const mediaTypesByKeys = () => {
  const output = {}
  mediaFileTypes.forEach(type => { output[type.value] = type })
  return output
}

//  { value: value }
export const mediaTypesKeys = () => {
  const output = {}
  mediaFileTypes.forEach(type => { output[type.value] = type.value })
  return output
}

//  [ value ]
export const mediaTypesList = () => {
  return mediaFileTypes.map(type => type.value)
}

export const filteredMediaTypes = (hideTypes = []) => {
  return mediaFileTypes.filter(mediaFileType => !hideTypes.includes(mediaFileType.value))
}

export default mediaFileTypes
